<script>
  import { Button, Input, InputGroup } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  export let accept;
  export let id;
  export let onLoad = () => {};
  export let onRemove = () => {};

  let fileInput;
  let files;

  const handleFileInput = (event) => {
    const file = event.target.files[0];

    if (file) {
      onLoad(file);
    }
  };

  const onRemoveFiles = () => {
    files = undefined;
    fileInput.value = '';

    onRemove();
  };
</script>

<InputGroup {...$$restProps}>
  <Input type="file" bind:files {accept} {id} bind:inner={fileInput} on:change={handleFileInput} />
  {#if files?.length}
    <Button class="px-2 py-1" on:click={onRemoveFiles}>
      <Icon name="trash-2" class="px-1" />
    </Button>
  {/if}
</InputGroup>
